export default __webpack_public_path__ + "static/media/150.dd8e8dec.jpg";